<section
  class="notificationSettings"
  [attr.aria-busy]="isLoading() || isSaving()"
  aria-labelledby="notificationSettingsTitle"
>
  <h3 id="notificationSettingsTitle">{{ "notification_settings.table.title" | translate }}</h3>

  @if (isLoading()) {
    <p role="status" aria-live="polite">{{ "notification_settings.table.loading" | translate }}</p>
  } @else if (loadError()) {
    <p role="alert">{{ "notification_settings.table.error" | translate }}</p>
    <p-button [label]="'notification_settings.table.retry' | translate" (onClick)="retryLoad()" />
  } @else if (settings().length === 0) {
    <p>{{ "notification_settings.table.empty" | translate }}</p>
  } @else {
    @if (snapshotChanged()) {
      <p role="status">{{ "notification_settings.table.snapshot_changed" | translate }}</p>
    }

    @if (!canUpdateSettings()) {
      <p class="readOnlyHint">{{ "notification_settings.table.read_only" | translate }}</p>
    }

    <form #settingsForm="ngForm" (ngSubmit)="save()">
      <p-table class="tableHeaderAlignTop" [value]="settings()">
        <ng-template #header>
          <tr>
            <th>{{ "notification_settings.settings.category" | translate }}</th>
            <th>{{ "notification_settings.settings.app" | translate }}</th>
            <th>{{ "notification_settings.settings.email" | translate }}</th>
          </tr>
        </ng-template>
        <ng-template #body let-setting>
          <tr>
            <td>{{ categoryTranslationKey(setting) | translate }}</td>
            <td class="channel">
              <p-checkbox
                [(ngModel)]="setting.app"
                [binary]="true"
                [disabled]="!canUpdateSettings() || isSaving()"
                [inputId]="setting.category + '-app'"
                [name]="setting.category + '-app'"
                [ariaLabel]="
                  (categoryTranslationKey(setting) | translate) +
                  ' ' +
                  ('notification_settings.settings.app' | translate)
                "
              />
            </td>
            <td class="channel">
              <p-checkbox
                [(ngModel)]="setting.email"
                [binary]="true"
                [disabled]="!canUpdateSettings() || isSaving()"
                [inputId]="setting.category + '-email'"
                [name]="setting.category + '-email'"
                [ariaLabel]="
                  (categoryTranslationKey(setting) | translate) +
                  ' ' +
                  ('notification_settings.settings.email' | translate)
                "
              />
            </td>
          </tr>
        </ng-template>
      </p-table>

      <div class="status" aria-live="polite">
        @if (isSaving()) {
          <p role="status">{{ "notification_settings.table.saving" | translate }}</p>
        } @else if (settingsForm.dirty && canUpdateSettings()) {
          <p>{{ "notification_settings.table.unsaved" | translate }}</p>
        }
      </div>

      @if (settingsForm.submitted && saveError()) {
        <p role="alert">{{ "notification_settings.table.save_error" | translate }}</p>
      }

      <div class="actions">
        @if (canUpdateSettings()) {
          <p-button
            type="submit"
            [label]="'notification_settings.settings.save' | translate"
            [loading]="isSaving()"
            [disabled]="!canSave()"
          />
        }
      </div>
    </form>
  }
</section>
